import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { StoreLineItem } from '../../package-details-v2/interface';

@Component({
  selector: 'store-products-nav-v2',
  templateUrl: './products-nav-v2.component.html',
  styleUrls: ['./products-nav-v2.component.scss'],
})
export class ProductsNavV2Component implements OnInit {
  @Input() items: StoreLineItem[];
  @Input() hideItemsNav: boolean;
  @Output() itemSelected = new EventEmitter<string>();

  selected_id = '';
  pageMarker = 0;

  ngOnInit(): void {
    if (this.items.length > 0) {
      this.selected_id = this.items[0].item?.id || '';
    }
  }

  onItemSelected(id: string): void {
    this.selected_id = id;
    this.itemSelected.emit(id);
  }

  moveSlides(slides: HTMLBodyElement): void {
    const sliderWidth = Math.round(slides.offsetWidth / slides.children[0].clientWidth);
    const numSlides = Math.ceil(slides.children.length / sliderWidth);
    if (numSlides === 0) {
      return;
    }
    const pageWidth = slides.offsetWidth;
    let move = 0;

    if (this.pageMarker === -1) {
      this.pageMarker = numSlides - 1; // go to end
      move = pageWidth * this.pageMarker;
      slides.style.left = `-${move}px`;
    } else if (this.pageMarker >= numSlides) {
      slides.style.left = '0px';
      this.pageMarker = 0; // reset
    } else {
      move = pageWidth * this.pageMarker;
      slides.style.left = `-${move}px`;
    }
  }

  pageNext(slides: HTMLBodyElement): void {
    this.pageMarker++;
    this.moveSlides(slides);
  }

  pagePrev(slides: HTMLBodyElement): void {
    this.pageMarker--;
    this.moveSlides(slides);
  }
}
